module.exports = __webpack_public_path__ + "static/media/back_icon.32531907.svg";